module.exports = __webpack_public_path__ + "static/media/3-regpus.4becfd66.png";